module.exports = __webpack_public_path__ + "static/media/investments-in.25ea74a2.svg";